import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "header_wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_toolbar, {
        color: "primary",
        dark: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            onClick: _ctx.routerBack,
            icon: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createTextVNode("mdi-chevron-left", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_v_toolbar_title, { class: "flex-grow-1 text-center ml-0" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.title), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_btn, {
            icon: "",
            disabled: "",
            style: {"visibility":"hidden"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode("mdi-chevron-left", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_v_list, { density: "compact" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.children, (c, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: c.childId
          }, [
            _createVNode(_component_v_list_item, {
              onClick: ($event: any) => (_ctx.to( c.childId, c.lastName + c.firstName ))
            }, {
              prepend: _withCtx(() => [
                _createVNode(_component_v_avatar, { class: "ml-2" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_img, {
                      src: _ctx.resolveChildImageUrl(c.imageUrl) || 'https://via.placeholder.com/240x180?text=Sample+Image+1'
                    }, null, 8, ["src"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_v_list_item_title, {
                  textContent: _toDisplayString(c.lastName + c.firstName)
                }, null, 8, ["textContent"])
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_v_divider)
          ], 64))
        }), 128))
      ]),
      _: 1
    })
  ]))
}